/**
 * @generated SignedSource<<01331fb8e58e48d66ccebd9d6948d994>>
 * @relayHash 964e4c92d55b3529aaa8e1afdece7358
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6e0c4088af79c8e9a96c1d7238282d6ae6bece60584d291f463388aacd92a669

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6e0c4088af79c8e9a96c1d7238282d6ae6bece60584d291f463388aacd92a669",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
